var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargeGreenLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L48 0 48 48 0 48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CA349",
    d: "M36.25 17.333h-1.875v-3.81C34.375 8.268 30.175 4 25 4s-9.375 4.267-9.375 9.524v3.81H13.75c-2.063 0-3.75 1.714-3.75 3.809V40.19c0 2.096 1.688 3.81 3.75 3.81h22.5c2.063 0 3.75-1.714 3.75-3.81V21.143c0-2.095-1.688-3.81-3.75-3.81zm0 20.953c0 1.047-.844 1.904-1.875 1.904h-18.75c-1.031 0-1.875-.857-1.875-1.904V23.048c0-1.048.844-1.905 1.875-1.905h18.75c1.031 0 1.875.857 1.875 1.905v15.238zM25 34.476c-2.063 0-3.75-1.714-3.75-3.81 0-2.095 1.688-3.809 3.75-3.809 2.063 0 3.75 1.714 3.75 3.81 0 2.095-1.688 3.81-3.75 3.81zm-5.625-17.143v-3.81c0-3.161 2.512-5.713 5.625-5.713s5.625 2.552 5.625 5.714v3.81h-11.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeGreenLock);
export default __webpack_public_path__ + "static/media/large-green-lock.9d34001697a7b9cefefd9aa84b2140fd.svg";
export { ForwardRef as ReactComponent };